import { useEffect, useState } from "react";
import styles from "./MenuCard.module.css";
import Papa from "papaparse";

const FOOD_SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTLXSAv6_wnOBucR9RtfTPzn1WI2w6hhbC3fcyB-CiJsuelFS5Gmv7_tuTI-Xh0i8geuq9cplQlccvE/pub?output=csv";
const DRINKS_SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnmjXMBm8u5bSHpB0YHtOmOt-apNw1Yacif8PlB8_XH4NlsGcWt3CNFdQok5yeIQjws9gZ5GvsphRv/pub?output=csv";

const MenuCard = () => {
    const [menuData, setMenuData] = useState([]);
    const [activeMenu, setActiveMenu] = useState("food"); // food | drinks

    useEffect(() => {
        const sheetUrl =
            activeMenu === "food"
                ? FOOD_SHEET_URL
                : DRINKS_SHEET_URL;

        fetch(sheetUrl)
            .then((response) => response.text())
            .then((csvText) => {
                Papa.parse(csvText, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        const grouped = groupByCategory(results.data);
                        setMenuData(grouped);
                    },
                });
            })
            .catch((error) =>
                console.error("Error fetching sheet:", error)
            );
    }, [activeMenu]); // 🔥 refetch when tab changes

    const groupByCategory = (data) => {
        const categories = {};

        data.forEach((row) => {
            const category = row["Category"]?.trim();
            if (!category) return;

            if (!categories[category]) categories[category] = [];

            // 👇 For Drinks sheet (30ML / Bottle pricing)
            if (activeMenu === "drinks") {
                categories[category].push({
                    name: row["Item Name"],
                    price30: row["30ML Price (INR)"],
                    bottle: row["Bottle Price (INR)"],
                });
            } else {
                // 👇 For Food sheet
                // 👇 For Food sheet
                categories[category].push({
                    name: row["Item Name"],
                    description: row["Description"],
                    price: row["Price (INR)"],
                    isVeg: row["IsVeg"] === "TRUE",

                    allergens: {
                        gluten: row["Gluten"] === "Yes",
                        dairy: row["Dairy"] === "Yes",
                        eggs: row["Eggs"] === "Yes",
                        soy: row["Soy"] === "Yes",
                        nuts: row["Nuts"] === "Yes",
                        seafood: row["Seafood"] === "Yes",
                        sesame: row["Sesame"] === "Yes",
                    }
                });

            }
        });

        return Object.entries(categories).map(
            ([category, items]) => ({
                category,
                items,
            })
        );
    };

    return (
        <section className={styles.section}>

            {/* ================= SELECTOR ================= */}
            <div className={styles.fdselector}>
                <button
                    className={activeMenu === "food" ? styles.activeTab : ""}
                    onClick={() => setActiveMenu("food")}
                >
                    Food Menu
                </button>

                <span className={styles.separator}>|</span>

                <button
                    className={activeMenu === "drinks" ? styles.activeTab : ""}
                    onClick={() => setActiveMenu("drinks")}
                >
                    Drinks Menu
                </button>
            </div>


            <div className={styles.container}>
                {menuData.map((category, index) => (
                    <div key={index} className={styles.categoryBlock}>
                        <h2 className={styles.categoryTitle}>
                            {category.category}
                        </h2>

                        {category.items.map((item, i) => (
                            <div key={i} className={styles.menuItem}>
                                <div className={`${styles.row} ${activeMenu === "drinks" ? styles.drinkRow : ""}`}>

                                    {/* LEFT SIDE */}
                                    <div className={styles.left}>
                                        <h3 className={styles.itemName}>
                                            {item.name}
                                        </h3>

                                        {/* FOOD MENU */}
                                        {activeMenu === "food" && (
                                            <>
                                                {item.description && (
                                                    <p className={styles.description}>
                                                        {item.description}
                                                    </p>
                                                )}

                                                <div className={styles.tags}>
                                                    {/* Veg / Non-Veg */}
                                                    {item.isVeg !== undefined && (
                                                        <span className={item.isVeg ? styles.veg : styles.nonVeg}>
                                                            {item.isVeg ? "Veg" : "Non-Veg"}
                                                        </span>
                                                    )}

                                                    {/* Only render allergens if they exist */}
                                                    {item.allergens &&
                                                        Object.entries(item.allergens).map(
                                                            ([key, value]) =>
                                                                value && (
                                                                    <span key={key} className={styles.tag}>
                                                                        {key.charAt(0).toUpperCase() + key.slice(1)}
                                                                    </span>
                                                                )
                                                        )}
                                                </div>

                                            </>
                                        )}
                                    </div>

                                    {/* RIGHT SIDE PRICING */}
                                    <div className={styles.price}>
                                        {activeMenu === "food" && (
                                            <>₹ {item.price}</>
                                        )}

                                        {activeMenu === "drinks" && (
                                            <>
                                                {item.price30 && (
                                                    <span className={styles.inlinePrice}>
                                                        30ML ₹ {item.price30}
                                                    </span>
                                                )}
                                                {item.bottle && (
                                                    <span className={styles.inlinePrice}>
                                                        BTL ₹ {item.bottle}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </div>

                                </div>
                            </div>
                        ))}

                    </div>
                ))}
            </div>
        </section>
    );
};

export default MenuCard;
